import { render } from "./MetricSleepDuration.vue?vue&type=template&id=b85a4252"
import script from "./MetricSleepDuration.vue?vue&type=script&lang=js"
export * from "./MetricSleepDuration.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__